import { apiCall } from "../configs/axiosConfigs";
const BASE_URL = `/ecommerce/address`;

const withQuery = (base, params) => {
  if (!params) return base;
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
  return qs ? `${base}?${qs}` : base;
};

export const addressApi = {
  async getAddressByPostalCode(payload) {
    return apiCall({
      url: `${BASE_URL}/getAddressByPostalCode/${payload}`,
      method: "GET",
    });
  },
  async addAddressCustomer(payload) {
    return apiCall({
      url: `${BASE_URL}/addAddress`,
      method: "POST",
      data: payload,
    });
  },
  async deleteAddressCustomer(payload) {
    return apiCall({
      url: `${BASE_URL}/deleteAddress/${payload.idCustomer}/${payload.idAddress}`,
      method: "DELETE",
    });
  }
};

export { withQuery };
